import React from 'react';
import Dialog from '@mui/material/Dialog';
import DialogContent from '@mui/material/DialogContent';
import { Button } from '@src/components/ui/button/button';
import { cn } from '@src/utils/ui';
import HomeOutlinedIcon from '@mui/icons-material/HomeOutlined';
import BuildOutlinedIcon from '@mui/icons-material/BuildOutlined';

export const OnBoardingRoleSelect = () => {
    return (
        <Dialog open aria-labelledby='alert-dialog-title' aria-describedby='alert-dialog-description' maxWidth='md'>
            <DialogContent>
                <div className='tw-space-y-[16px] tw-text-bcaa-grey-900 tw-text-[16px]'>
                    <div className='tw-grid tw-grid-cols-1 lg:tw-grid-cols-2 tw-gap-[16px] lg:tw-items-stretch'>
                        <div className='tw-border tw-border-[#DCDCDC] tw-p-[12px] tw-flex tw-flex-col tw-gap-[16px]'>
                            <div className='tw-flex tw-items-center tw-gap-[16px] tw-text-[20px] tw-font-[500]'>
                                <div className='tw-p-[10px]'>
                                    <HomeOutlinedIcon sx={{ fontSize: 50, color: '#0050C4' }} />
                                </div>
                                <p>Need help around the home?</p>
                            </div>

                            <div className='tw-grow'>
                                <p>Chores, repairs, and more, help is just a click away. Search and book in minutes.</p>
                                <br />
                                <p>
                                    Taskers are now insured for eligible tasks booked through BCAA Task Marketplace.**{' '}
                                    <a href='https://task.marketplace.bcaa.com/pages/tasker-insurance' style={{ color: '#0050C4' }}>
                                        <u>Learn more</u>
                                    </a>
                                </p>
                            </div>
                            <Button
                                className={cn('tw-p-[8px] tw-text-[14px] tw-w-full tw-uppercase tw-mt-auto')}
                                autoFocus
                                variant='contained'
                                loadingPosition='start'
                                href='/search'
                            >
                                Find a task
                            </Button>
                        </div>

                        <div className='tw-border tw-border-[#DCDCDC] tw-p-[12px] tw-flex tw-flex-col tw-gap-[16px]'>
                            <div className='tw-flex tw-items-center tw-gap-[16px] tw-text-[20px] tw-font-[500]'>
                                <div className='tw-p-[10px]'>
                                    <BuildOutlinedIcon
                                        sx={{ fontSize: 40, color: '#0050C4', transform: 'scaleX(-1)' }}
                                    />
                                </div>
                                <p>List your services. Get hired. Earn more.</p>
                            </div>
                            <div className='tw-grow'>
                                <p>Choose your hours, set your rate, and keep 100% of what you charge.</p>
                                <br />
                                <p>
                                    Sign up today for an introductory rate of <strong>$1 /month*</strong>
                                </p>
                                <br />
                                <p>
                                    Tasker Insurance is now available on eligible tasks completed through BCAA Task
                                    Marketplace.**{' '}
                                    <a href='https://task.marketplace.bcaa.com/pages/tasker-insurance' style={{ color: '#0050C4' }}>
                                        <u>Learn more</u>
                                    </a>
                                </p>
                            </div>
                            <Button
                                href='/users/onboard-step-1'
                                className={cn('tw-p-[8px] tw-text-[14px] tw-w-full tw-uppercase tw-mt-auto')}
                                autoFocus
                                variant='contained'
                                loadingPosition='start'
                            >
                                Become a tasker
                            </Button>
                        </div>
                    </div>
                    <p className='tw-text-[12px] tw-text-bcaa-grey-700'>
                        *The introductory subscription fee of $1 per month is valid for your first six months of
                        subscription (excluding taxes). After this date, the subscription fee will automatically adjust
                        to the standard rate of $12.95.
                    </p>
                    <p className='tw-text-[12px] tw-text-bcaa-grey-700'>
                        **Insurance coverage is subject to the Tasker Insurance policy terms and conditions, including
                        eligibility requirements, limitations, and exclusions. Tasker Insurance is a group insurance
                        policy underwritten by BCAA Insurance Corporation and issued to B.C.A.A. Holdings Ltd. BCAA
                        Insurance Corporation is a subsidiary of B.C.A.A. Holdings Ltd.
                    </p>
                </div>
            </DialogContent>
        </Dialog>
    );
};
